export default __webpack_public_path__ + "static/media/html5.aa528e9e.png";